const $win = $(window);
const $doc = $(document);

$('.js-radio-option').on('change', function() {
  const $form = $(this).closest('form');
  const $productSelect = $form.find('.product-select');
  let optionSelector = '';

  $form.find('.product__radios input:checked').each(function(ind, el) {
    const $this = $(this);
    optionSelector += '[data-' + $this.data('option') + '="' + $this.val() + '"]';
  });

  $productSelect
    .find(optionSelector)
    .first()
    .prop('selected', true);
  $productSelect.trigger('change');
  $(this)
    .closest('.js-product-variant')
    .find('.js-variant-value')
    .text($(this).data('value'));
});
